<template lang="pug">
PageServices(v-if='!isSubPage')
PageServicesPage(v-else, :alias='alias')
</template>

<script lang="ts" setup>
const { isSubPage, alias } = useMeta();
</script>
